<template>
  <div class="yy">
    <!-- 上盒子 -->
    <div class="yy-box1">
        <!-- <div class="yy-box1-1">走进翼博</div> -->
        <ul>
            <li><router-link to="/honor/myzs1">企业简介</router-link></li>
            <li><router-link to="/honor/myzs2">企业文化</router-link></li>
            <li><router-link to="/honor/myzs3">组织架构</router-link></li>
            <li><router-link to="/honor/myzs4">企业资质</router-link></li>
            <li><router-link to="/honor/myzs7">企业体系认证</router-link></li>
            <li><router-link to="/honor/myzs8">企业信用认证</router-link></li>
            <li><router-link to="/honor/myzs5">荣誉证书</router-link></li>
            <li><router-link to="/honor/myzs6">新闻动态</router-link></li>
        </ul>
    </div>

    <!-- 下盒子 -->
    <div class="qyzz">
        <!-- <img src="@/assets/ryzs/ybcy.jpg" alt=""> -->
        <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-45-12-923%E9%83%91%E5%B7%9E%E7%BF%BC%E5%8D%9A%E9%A4%90%E9%A5%AE%E4%BC%81%E4%B8%9A%E7%AE%A1%E7%90%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8.jpg" alt="">
        <!-- <img src="@/assets/ryzs/change01.png" alt=""> -->
        <!-- <img src="@/assets/ryzs/change02.png" alt=""> -->
        <!-- <img src="@/assets/ryzs/3.jpg" alt=""> -->
        <!-- <img src="@/assets/ryzs/4.jpg" alt=""> -->
        <!-- <img src="@/assets/ryzs/食品经营许可证.png" alt=""> -->
        <!-- 食品经营许可证 -->
        <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-45-44-212%E7%BF%BC%E5%8D%9A%E9%A4%90%E9%A5%AE%E9%A3%9F%E5%93%81%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81%E5%89%AF%E6%9C%AC.jpg" alt="">
        <img src="@/assets/ryzs/6.jpg" alt="">
        <!-- <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-47-36-910%E8%B4%A8%E9%87%8F%E7%AE%A1%E7%90%86%E4%BD%93%E7%B3%BB%E8%AE%A4%E8%AF%81%E8%AF%81%E4%B9%A6%E5%89%AF%E6%9C%AC.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-46-33-854%E9%A3%9F%E5%93%81%E5%AE%89%E5%85%A8%E7%AE%A1%E7%90%86%E4%BD%93%E7%B3%BB%E8%AE%A4%E8%AF%81%E8%AF%81%E4%B9%A6%E5%89%AF%E6%9C%AC.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-47-14-760%E8%81%8C%E4%B8%9A%E5%81%A5%E5%BA%B7%E5%AE%89%E5%85%A8%E7%AE%A1%E7%90%86%E4%BD%93%E7%B3%BB%E8%AE%A4%E8%AF%81%E8%AF%81%E4%B9%A6%E5%89%AF%E6%9C%AC.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-46-20-920%E7%8E%AF%E5%A2%83%E7%AE%A1%E7%90%86%E4%BD%93%E7%B3%BB%E8%AE%A4%E8%AF%81%E8%AF%81%E4%B9%A6%E5%89%AF%E6%9C%AC.jpg" alt="">
        <img class="sizeSty" src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-46-51-315%E5%8D%B1%E5%AE%B3%E5%88%86%E6%9E%90%E4%B8%8E%E5%85%B3%E9%94%AE%E6%8E%A7%E5%88%B6%E7%82%B9%EF%BC%88HACCP%EF%BC%89%E4%BD%93%E7%B3%BB%E8%AE%A4%E8%AF%81%E8%AF%81%E4%B9%A6%E5%89%AF%E6%9C%AC.jpg" alt="">
        <img class="sizeSty" src="@/assets/ryzs/01.png" alt=""> -->
    </div>
  </div>
</template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style scoped>
  *{
    box-sizing: border-box;
}
  .qyzz  {
    width: 60%;
    margin: 0 auto;
  }
  .sizeSty {
    width: 40%;
  }
  </style>